import React, { useState } from 'react';
import api from '../../utils/api';
import { handleApiError } from '../../utils/errorHandler';

const AddParentModal = ({ onClose, onParentAdded }) => {
  const [parentFormData, setParentFormData] = useState({
    username: '',
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAddParent = async (e) => {
    e.preventDefault();
    setError(null);

    if (!parentFormData.username || !parentFormData.email || !parentFormData.password) {
      setError('All fields are required');
      return;
    }

    try {
      setLoading(true);
      await api.post('/register/parent', {
        username: parentFormData.username,
        email: parentFormData.email,
        password: parentFormData.password
      });
      
      // Reset form and close modal
      setParentFormData({ username: '', email: '', password: '' });
      onClose();
      
      // Reload parents list
      if (onParentAdded) {
        await onParentAdded();
      }
    } catch (err) {
      console.error('Error creating parent:', err);
      setError(handleApiError(err, 'Unable to create parent account.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{
        maxWidth: '500px'
      }}>
        <div className="modal-header">
          <h2>Add New Parent</h2>
          <button
            className="modal-close-btn"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>
        <div className="modal-body">
          {error && (
            <div className="error-message" style={{ marginBottom: '1rem', padding: '1rem', background: '#fee', color: '#c33', borderRadius: '8px' }}>
              {error}
            </div>
          )}
          <form onSubmit={handleAddParent} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div className="form-group">
              <label htmlFor="parent-username">Username</label>
              <input
                id="parent-username"
                type="text"
                value={parentFormData.username}
                onChange={(e) => setParentFormData(prev => ({ ...prev, username: e.target.value }))}
                placeholder="Enter username"
                required
                minLength={3}
                maxLength={50}
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  fontSize: '0.9rem',
                  border: '1px solid #cbd5e0',
                  borderRadius: '4px'
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="parent-email">Email</label>
              <input
                id="parent-email"
                type="email"
                value={parentFormData.email}
                onChange={(e) => setParentFormData(prev => ({ ...prev, email: e.target.value }))}
                placeholder="Enter email"
                required
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  fontSize: '0.9rem',
                  border: '1px solid #cbd5e0',
                  borderRadius: '4px'
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="parent-password">Password</label>
              <input
                id="parent-password"
                type="password"
                value={parentFormData.password}
                onChange={(e) => setParentFormData(prev => ({ ...prev, password: e.target.value }))}
                placeholder="Enter password (min 6 characters)"
                required
                minLength={6}
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  fontSize: '0.9rem',
                  border: '1px solid #cbd5e0',
                  borderRadius: '4px'
                }}
              />
            </div>
            <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1rem' }}>
              <button
                type="button"
                className="btn-secondary"
                onClick={() => {
                  onClose();
                  setParentFormData({ username: '', email: '', password: '' });
                }}
                disabled={loading}
                style={{ flex: 1, padding: '0.75rem', fontSize: '0.9rem' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn"
                disabled={loading || !parentFormData.username || !parentFormData.email || !parentFormData.password}
                style={{ flex: 1, padding: '0.75rem', fontSize: '0.9rem' }}
              >
                {loading ? 'Creating...' : 'Create Parent'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddParentModal;

